// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"4a007954","113":"4d4f21c7","179":"2914b04c","226":"38109a46","532":"20e5e6d1","754":"89f5a508","768":"387d5745","873":"2a8cb992"}[chunkId] + ".css";
};